import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "./authCrud";
import * as _products from "../../../../app/pages/CatalogProducts/operations"
export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Update: "[Update] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  LoadProducts: "[Load Products] Action"
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  products: []
};

export const reducer = persistReducer(
  { storage, key: "v711-demo1-auth", whitelist: ["user", "authToken", "products"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }
      case actionTypes.Update: {
        const { user } = action.payload;
        return { ...state, user };
      }
      case actionTypes.LoadProducts: {
        const { products } = action.payload;
        return { ...state, products };
      }
      default:
        return state;
    }
  }
);

export const actions = {
  login: authToken => ({ type: actionTypes.Login, payload: { authToken } }),
  register: authToken => ({ type: actionTypes.Register, payload: { authToken } }),
  update: user => ({ type: actionTypes.Update, payload: { user } }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: user => ({ type: actionTypes.UserRequested, payload: { user } }),
  fulfillUser: user => ({ type: actionTypes.UserLoaded, payload: { user } }),
  loadProducts: products => ({ type: actionTypes.LoadProducts, payload: { products } })
};

export function* saga() {
  yield takeLatest(actionTypes.LoadProducts, function* loadProductsSaga(products) {
    yield put(actions.loadProducts(products));
  });
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Update, function* loginSaga({ payload }) {
    console.log(payload)
    yield put(actions.fulfillUser(payload.user));
    yield put(actions.requestUser());

  });
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const { data: user } = yield getUserByToken();
    yield put(actions.fulfillUser(user));
  });
}
